<template>
  <section class="trainings">
    <TopBanner class="mb-16" :item="banner" />

    <div class="container _py-16 _py-md-12">
      <AppBtnBreadCrumb class="_mb-4" />
      <QualificationFilter :access="true" class="_px-md-4" />
      <div class="sections__list d-grid row-1-1 gap-32">
        <VideoCard
          @like="like"
          @favorite="favorite"
          @downloadFile="downloadFile"
          @viewItem="viewItem"
          @setVideoProgress="setVideoProgress"
          v-for="(block, ind) in filteredList"
          :key="ind"
          :hideDownload="true"
          :item="getTranslate(block)"
        ></VideoCard>
      </div>
    </div>
  </section>
</template>

<script>
import TopBanner from '@/components/UI/banners/TopBanner'
import VideoCard from '@/components/UI/cards/VideoCard'
import AppBtnBreadCrumb from '@/components/UI/buttons/AppBtnBreadCrumb'
import QualificationFilter from '@/components/UI/QualificationFilter'
import download from '@/mixins/download'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Qualification',
  components: {
    TopBanner,
    VideoCard,
    AppBtnBreadCrumb,
    QualificationFilter,
  },
  mixins: [download],
  data: () => ({
    accessDenied: false,
  }),
  computed: {
    ...mapGetters([
      'Sections',
      'getTrainingsListExclusive',
      'getTrainingsListAll',
    ]),
    sectionsList() {
      const vm = this
      return this.$t('another_sections') &&
        Array.isArray(this.$t('another_sections'))
        ? this.$t('another_sections').filter((el) => !el.hide).map(function (el) {
            return {
              ...el,
              image: require(`@/assets/img/sections/${el.image}`),
              route: vm.helpers.buildRoute(el.route),
            }
          })
        : null
    },
    currentLocale() {
      return this.Trans.currentLocale
    },
    filteredList() {
      return this.getTrainingsListExclusive.filter((el) =>
        el.access_groups.includes('school_2500')
      )
    },
    banner() {
      return {
        title: this.$t('pages.qualifications.title'),
        descr: this.$t('pages.qualifications.description'),
        theme: 'light',
        images: [
          {
            src: require('@/assets/img/banners/trainings/trainings-375_new.jpg'),
            media: '(max-width: 743px)',
          },
          {
            src: require('@/assets/img/banners/trainings/trainings-768_new.jpg'),
            media: '(max-width: 1220px)',
          },
          {
            src: require('@/assets/img/banners/trainings/trainings-1440_new.jpg'),
            media: '(max-width: 1919px)',
          },
          {
            src: require('@/assets/img/banners/trainings/trainings-1920_new.jpg'),
            media: '(min-width: 1920px)',
          },
        ],
      }
    },
  },
  methods: {
    ...mapActions([
      'fetchTrainingsList',
      'TrainingsSetVideoProgress',
      'TrainingsSetLike',
      'TrainingsSetFavorite',
      'TrainingsSetView',
    ]),
    getTranslate(item) {
      return {
        ...item,
        title: item.translates[0].title,
        description: item.translates[0].description,
        preview: item.translates[0].preview,
        file: item.translates[0].file || item.translates[0].file_link,
        file_size: item.translates[0].file_size,
        extras: item.translates[0].extras,
        date: `${this.$t(
          `interface.months[${new Date(item.created_at).getMonth()}]`
        )} ${new Date(item.created_at).getFullYear()}`,
      }
    },
    async updateList() {
      await this.fetchTrainingsList({
        lang: this.currentLocale,
        access: true,
        filter: this.filter,
      })
    },
    async like(id) {
      await this.TrainingsSetLike(id)
      await this.updateList()
    },
    async favorite(id) {
      await this.TrainingsSetFavorite(id)
      await this.updateList()
    },
    async setVideoProgress(id, time) {
      await this.TrainingsSetVideoProgress({
        id: id,
        progress: Math.round(time),
      })
      await this.updateList()
    },
    async viewItem(id) {
      await this.TrainingsSetView({ id: id, access: true })
      await this.updateList()
    },
  },
  async mounted() {
    if (
      !this.getTrainingsListExclusive ||
      !this.getTrainingsListExclusive.length
    ) {
      await this.fetchTrainingsList({
        lang: this.currentLocale,
        access: true,
      })
      if (
        !this.getTrainingsListExclusive.length &&
        !this.getTrainingsListExclusive.filter((el) =>
          el.access_groups.includes('school_2500')
        ).length
      ) {
        this.$router.push(this.helpers.buildRoute({ name: 'Trainings' }))
      }
    }
  },
}
</script>

<style lang="scss">
.row-1-1 {
  grid-template-columns: 1fr 1fr;

  @media screen and (max-width: 1220px) {
    grid-template-columns: 1fr;
  }
}

.gap-32 {
  grid-gap: 32px;
}
</style>
